var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_au_ocker/phone_number/index.js
// module id = 1081
// module chunks = 0